import React from 'react';

const UsageContext = React.createContext();

export default UsageContext;
